import constants from '@/constants';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isLocationFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.LOCATION);
    },

    isGeofenceFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.GEOFENCE);
    },
  },
};
